'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AutoSaveContainer from 'ContentEditorUI/containers/AutoSaveContainer';
import { getSaveData, getCanSave } from 'page-editor-ui/redux/selectors/saveSelectors';
import { getHasContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { validate } from 'page-editor-ui/redux/actions/pagePublishActions';
import { saveSettingsBuffer, fetchHasBufferedSettingsChanges } from 'theme-previewer-lib/actions/ThemeSettingsActions';
import { getCanUseUniversalThemeEditor } from 'page-editor-ui/redux/selectors/authSelectors';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getHasThemeUnsavedChanges } from 'theme-previewer-lib/selectors/themeSettingsMetaSelectors';
// @ts-expect-error not typed yet
import { AUTOSAVE_THEME_SAVE_PERIOD } from 'page-editor-ui/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const keysForHardSave = ['name', 'language', 'domain', 'slug', 'campaign', 'campaign_name', 'campaign_utm'];
const keysToReload = [
// changes require preview reload
'domain', 'head_html', 'footer_html', 'include_default_custom_css', 'enable_domain_stylesheets', 'enable_layout_stylesheets', 'attached_stylesheets', 'language', 'html_title', 'meta_description', 'featured_image'];
const mapStateToProps = state => {
  const hasContentModel = getHasContentModel(state);
  return {
    saveData: hasContentModel ? getSaveData(state) : null,
    canSave: getCanSave(state),
    hasTheme: getHasTheme(state),
    hasThemeUnsavedChanges: getHasThemeUnsavedChanges(state),
    canUseUniversalThemeEditor: getCanUseUniversalThemeEditor(state)
  };
};
const mapDispatchToProps = {
  validate,
  saveSettingsBuffer,
  fetchHasBufferedSettingsChanges
};
class PageAutoSaveContainer extends Component {
  componentDidUpdate() {
    const {
      hasThemeUnsavedChanges,
      canUseUniversalThemeEditor
    } = this.props;
    if (hasThemeUnsavedChanges && canUseUniversalThemeEditor) {
      setTimeout(() => {
        this.props.saveSettingsBuffer({
          isAutoSave: true,
          fromUniversal: true
        });
        this.props.fetchHasBufferedSettingsChanges();
      }, AUTOSAVE_THEME_SAVE_PERIOD);
    }
  }
  render() {
    const {
      saveData,
      isAppReadyForSaving,
      autoSaveDebounced,
      autoSave,
      canSave
    } = this.props;
    if (saveData && isAppReadyForSaving) {
      return /*#__PURE__*/_jsx(AutoSaveContainer, {
        autoSaveDebounced: autoSaveDebounced,
        autoSave: autoSave,
        saveData: saveData,
        canSave: canSave,
        keysForHardSave: keysForHardSave,
        validate: this.props.validate,
        keysToReload: keysToReload
      });
    }
    return null;
  }
}
PageAutoSaveContainer.propTypes = {
  saveData: PropTypes.object,
  canSave: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  isAppReadyForSaving: PropTypes.bool.isRequired,
  autoSaveDebounced: PropTypes.func.isRequired,
  autoSave: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(PageAutoSaveContainer);